import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: 60,
    textAlign: 'center'
  },
  title: {
    position: 'relative'
  }
}))
export default useStyles
